// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.UpdateRenterInfoByLandlordWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UpdateRenterInfoByLandlordWebApiRequestDto } from '../..';

export const UpdateRenterInfoByLandlordWebApiHandler_updateRenterInfoByLandlord_Path =
  '/api/web/v1/landlord/updateRenterInfoByLandlord';

/**
 * create or update renter by landlord
 */
export const UpdateRenterInfoByLandlordWebApiHandler_updateRenterInfoByLandlord = (
  postData: UpdateRenterInfoByLandlordWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateRenterInfoByLandlordWebApiRequestDto, void>(
    {
      endpoint: UpdateRenterInfoByLandlordWebApiHandler_updateRenterInfoByLandlord_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
